import React from 'react';
import {Button, Descriptions, Modal, message} from 'antd';
import styled from 'styled-components';
import {getNewOutlet, getOutlet, useOutlet} from 'reconnect.js';
import * as JStorage from 'rev.sdk.js/Actions/JStorage';
import * as AppActions from '../AppActions';
import * as AppActionsEx from '../AppActions/custom';
import DataJson from '../../data.json';
import {ModalCustomStyle} from '../AppContext/customStyledCss';

getNewOutlet('admin-order-receipt-notify-modal', null, {autoDelete: false});

export function showAdminOrderReceiptNotifyModal(data) {
  getOutlet('admin-order-receipt-notify-modal').update(data);
}

async function resolveReceiptEmail(instance) {
  const buyerEmail = (instance.buyer_email || '').trim();
  if (buyerEmail) {
    return {email: buyerEmail, source: '訂單購買人 email'};
  }

  if (!instance.owner) {
    return {email: '', source: ''};
  }

  const profile = await JStorage.fetchOneDocument(
    'user_profile',
    {owner: instance.owner},
    {email: 1, EMAIL2: 1},
  );

  const profileEmail = (profile?.email || '').trim();
  if (profileEmail) {
    return {email: profileEmail, source: '會員 email'};
  }

  const email2 = (profile?.EMAIL2 || '').trim();
  return {email: email2, source: email2 ? '會員備用 email' : ''};
}

function AdminOrderReceiptNotifyModal(props) {
  const [data, setData] = useOutlet('admin-order-receipt-notify-modal');

  return (
    <Modal
      title="寄送收據通知"
      footer={null}
      width={500}
      style={{top: 20, padding: 0}}
      visible={!!data}
      onCancel={() => setData(null)}
      destroyOnClose={true}>
      {data && <ModalContent order={data.order} setData={setData} />}
    </Modal>
  );
}

function ModalContent(props) {
  const {order, setData} = props;
  const [emailInfo, setEmailInfo] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    resolveReceiptEmail(order)
      .then(setEmailInfo)
      .catch(() => setEmailInfo({email: '', source: ''}))
      .finally(() => setLoading(false));
  }, [order]);

  if (loading) {
    return <p>查找收件 Email 中...</p>;
  }

  if (!emailInfo?.email) {
    return (
      <p>
        找不到可寄送的 Email（buyer_email / email / EMAIL2），請先補齊資料。
      </p>
    );
  }

  async function handleSend() {
    try {
      AppActions.setLoading(true);

      const isFeeOrder = order.items[0].name.indexOf('常年會費') > -1;
      const isCrossOrder = order.items[0].name.indexOf('跨區會費') > -1;

      const buyer_name = order.buyer_name;
      const product_name = `${order.items[0].name}`;

      const subject =
        isFeeOrder || isCrossOrder
          ? `收據開立通知 - ${order.buyer_name} ${product_name}`
          : `收據開立通知 - ${order.buyer_name} ${product_name}`;

      await AppActionsEx.sendEmail({
        sender: 'on-order-create',
        data: {
          receipt_url: `${DataJson.webHost}/print-preview-receipt?order_number=${order.order_number}`,
          subject,
          product_name,
          buyer_name,
        },
        emails: [emailInfo.email],
      });

      message.success('收據通知寄送成功');
      setData(null);
    } catch (err) {
      console.warn(err);
      message.error('寄送收據通知失敗');
    } finally {
      AppActions.setLoading(false);
    }
  }

  return (
    <ModalContentWrapper>
      <Descriptions column={1} bordered size="small" style={{marginBottom: 16}}>
        <Descriptions.Item label="收件 Email">
          {emailInfo.email}
        </Descriptions.Item>
        <Descriptions.Item label="來源">{emailInfo.source}</Descriptions.Item>
      </Descriptions>
      <div style={{display: 'flex', justifyContent: 'flex-end', gap: 8}}>
        <Button onClick={() => setData(null)}>取消</Button>
        <Button type="primary" onClick={handleSend}>
          確認寄送
        </Button>
      </div>
    </ModalContentWrapper>
  );
}

const ModalContentWrapper = styled(ModalCustomStyle)``;

export default AdminOrderReceiptNotifyModal;
